// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { GraphQLApiError } from './GraphQLApiError';
import { validationErrorMap } from './validation';
/**
 * @internal
 */
export function assertValidationError(assertion, name) {
    const { message, recoverySuggestion } = validationErrorMap[name];
    if (!assertion) {
        throw new GraphQLApiError({ name, message, recoverySuggestion });
    }
}
